export const blockIconsSocialMonitorHeartNew = (
	<span className='material-symbols-outlined'>monitor_heart</span>
);
